// import { useEffect, useState } from "react";
// import { useAppStore } from "lib/store/useAppStore";
// import { postChangePalette } from "lib/api/postChangePalette";
// import ImgEditor from "components/project/ImgEditor";
// import SingleImageDownloadBtn from "components/project/SingleImageDownloadBtn";
// import FileValueTable from "components/project/FileValueTable";
// import TripleSpotOverlay from "components/project/FileImgEditor/TripleSpotOverlay";
// import { getEditorSize } from "lib/utils/getEditorSize";

// export default function ThermalPanel({
//   file,
//   refetch,
//   circles,
//   setCircles,
//   currentPaletteOptionNumber,
//   setCurrentPaletteOptionNumber,
//   themralCaptureTargetDefault,
//   tripleSpotCaptureTarget,
//   currentThermalImg,
//   setCurrentThermalImg,
//   imgChangeLoading,
//   setImgChangeLoading,
//   t,
// }) {
//   const [changing, setChanging] = useState(false);
//   const showAlert = useAppStore((s) => s.showAlert);
//   const editorSize = getEditorSize(file?.csv_origin, "thermal");

//   useEffect(() => {
//     if (file?.thermal_palette != null) {
//       setCurrentPaletteOptionNumber(file.thermal_palette);
//     }
//   }, [file?.thermal_palette, setCurrentPaletteOptionNumber]);

//   return (
//     <div className="thermalPanel">
//       <PaletteOptionsList
//         currentPaletteOptionNumber={currentPaletteOptionNumber}
//         setCurrentPaletteOptionNumber={setCurrentPaletteOptionNumber}
//         upload_id={file?.upload_id}
//         refetch={refetch}
//         changing={changing}
//         setChanging={setChanging}
//         setCurrentThermalImg={setCurrentThermalImg}
//         imgChangeLoading={imgChangeLoading}
//         setImgChangeLoading={setImgChangeLoading}
//         showAlert={showAlert}
//         t={t}
//       />
//       <div>
//         <div>
//           <div className="imgDownloadBtnBox">
//             <p className="imgTitleP">
//               {t("imageFileIndex.subTitle.shootingImage")}
//             </p>
//             <SingleImageDownloadBtn
//               fileName={`${file?.clean_file_name}_thermal`}
//               captureTargetRef={themralCaptureTargetDefault}
//               t={t("imageFileIndex.buttons.singleImageDownload")}
//             />
//           </div>
//           <div ref={themralCaptureTargetDefault}>
//             <ImgEditor
//               parsedData={file}
//               src={currentThermalImg || file?.image_thermal}
//               type="thermal"
//               currentPaletteOptionNumber={currentPaletteOptionNumber}
//               loading={imgChangeLoading}
//             />
//           </div>
//         </div>

//         <div>
//           <div className="imgDownloadBtnBox">
//             <p className="imgTitleP">
//               {t("imageFileIndex.subTitle.tripleSpot")}
//             </p>
//             <SingleImageDownloadBtn
//               fileName={`${file?.clean_file_name}_triplespot`}
//               captureTargetRef={tripleSpotCaptureTarget}
//               t={t("imageFileIndex.buttons.singleImageDownload")}
//             />
//           </div>
//           <div
//             ref={tripleSpotCaptureTarget}
//             style={{ width: editorSize.width, height: editorSize.height }}
//             className="tripleSpotImgBox"
//           >
//             <TripleSpotOverlay
//               file={file}
//               circles={circles}
//               setCircles={setCircles}
//               editorSize={editorSize}
//             />
//             <ImgEditor
//               parsedData={file}
//               type="thermal"
//               type2="tripleSpot"
//               src={currentThermalImg || file?.image_thermal}
//               currentPaletteOptionNumber={currentPaletteOptionNumber}
//               loading={imgChangeLoading}
//             />
//           </div>
//         </div>

//         <div>
//           <p className="imgTitleP">
//             {t("imageFileIndex.subTitle.MeasurementValue")} {file?.volume}
//           </p>
//           <FileValueTable t={t} parsedData={file} type="thermal" />
//         </div>
//       </div>
//     </div>
//   );
// }

// export function PaletteOptionsList({
//   currentPaletteOptionNumber,
//   setCurrentPaletteOptionNumber,
//   setCurrentThermalImg,
//   upload_id,
//   changing,
//   setChanging,
//   imgChangeLoading,
//   setImgChangeLoading,
//   showAlert,
//   t,
// }) {
//   const handleClick = async (val) => {
//     if (val === currentPaletteOptionNumber) return;
//     if (!upload_id) return;
//     if (changing) return;

//     setChanging(true);
//     setImgChangeLoading(true);
//     const prev = currentPaletteOptionNumber;

//     try {
//       const { success, message, messageKey, messageParams, image } =
//         await postChangePalette(upload_id, val);

//       if (!success) {
//         setCurrentPaletteOptionNumber(prev);
//         showAlert({
//           text: message,
//           messageKey,
//           messageParams,
//           success,
//           autoClose: true,
//           duration: 3000,
//         });
//         return;
//       }

//       showAlert({
//         text: message,
//         messageKey,
//         messageParams,
//         success,
//         autoClose: true,
//         duration: 1000,
//       });
//       setCurrentThermalImg(image);
//       setCurrentPaletteOptionNumber(val);
//     } catch (e) {
//       setCurrentPaletteOptionNumber(prev);
//       showAlert({
//         textKey: "api.project.palette.change.failed",
//         success: false,
//         autoClose: true,
//       });
//       console.error(e);
//     } finally {
//       setChanging(false);
//       setImgChangeLoading(false);
//     }
//   };

//   return (
//     <ul className={`paletteOptionsList${changing ? " is-loading" : ""}`}>
//       {paletteLabels.map(({ labelKey, src, thermal_palette }) => {
//         const label = t(`imageFileIndex.paletteLabels.${labelKey}`);

//         return (
//           <li
//             onClick={() => handleClick(thermal_palette)}
//             key={labelKey}
//             className={`paletteOption ${
//               thermal_palette === currentPaletteOptionNumber ? "active" : ""
//             } ${changing || imgChangeLoading ? "is-disabled" : ""}`}
//           >
//             <p>{label}</p>
//             <img src={src} alt={label} />
//           </li>
//         );
//       })}
//     </ul>
//   );
// }

// export const paletteLabels = [
//   {
//     labelKey: "autumn",
//     src: "/images/colorscale/colorscale_autumn.jpg",
//     thermal_palette: 0,
//   },
//   {
//     labelKey: "bone",
//     src: "/images/colorscale/colorscale_bone.jpg",
//     thermal_palette: 1,
//   },
//   {
//     labelKey: "jet",
//     src: "/images/colorscale/colorscale_jet.jpg",
//     thermal_palette: 2,
//   },
//   {
//     labelKey: "winter",
//     src: "/images/colorscale/colorscale_winter.jpg",
//     thermal_palette: 3,
//   },
//   {
//     labelKey: "rainbow",
//     src: "/images/colorscale/colorscale_rainbow.jpg",
//     thermal_palette: 4,
//   },
//   {
//     labelKey: "ocean",
//     src: "/images/colorscale/colorscale_ocean.jpg",
//     thermal_palette: 5,
//   },
//   {
//     labelKey: "summer",
//     src: "/images/colorscale/colorscale_summer.jpg",
//     thermal_palette: 6,
//   },
//   {
//     labelKey: "spring",
//     src: "/images/colorscale/colorscale_spring.jpg",
//     thermal_palette: 7,
//   },
//   {
//     labelKey: "cool",
//     src: "/images/colorscale/colorscale_cool.jpg",
//     thermal_palette: 8,
//   },
//   {
//     labelKey: "hsv",
//     src: "/images/colorscale/colorscale_hsv.jpg",
//     thermal_palette: 9,
//   },
//   {
//     labelKey: "pink",
//     src: "/images/colorscale/colorscale_pink.jpg",
//     thermal_palette: 10,
//   },
//   {
//     labelKey: "hot",
//     src: "/images/colorscale/colorscale_hot.jpg",
//     thermal_palette: 11,
//   },
//   {
//     labelKey: "parula",
//     src: "/images/colorscale/colorscale_parula.jpg",
//     thermal_palette: 12,
//   },
//   {
//     labelKey: "magma",
//     src: "/images/colorscale/colorscale_magma.jpg",
//     thermal_palette: 13,
//   },
//   {
//     labelKey: "inferno",
//     src: "/images/colorscale/colorscale_inferno.jpg",
//     thermal_palette: 14,
//   },
//   {
//     labelKey: "plasma",
//     src: "/images/colorscale/colorscale_plasma.jpg",
//     thermal_palette: 15,
//   },
//   {
//     labelKey: "viridis",
//     src: "/images/colorscale/colorscale_viridis.jpg",
//     thermal_palette: 16,
//   },
//   {
//     labelKey: "cividis",
//     src: "/images/colorscale/colorscale_cividis.jpg",
//     thermal_palette: 17,
//   },
//   {
//     labelKey: "twilight",
//     src: "/images/colorscale/colorscale_twilight.jpg",
//     thermal_palette: 18,
//   },
//   {
//     labelKey: "shifted",
//     src: "/images/colorscale/colorscale_twilight_shifted.jpg",
//     thermal_palette: 19,
//   },
//   {
//     labelKey: "turbo",
//     src: "/images/colorscale/colorscale_turbo.jpg",
//     thermal_palette: 20,
//   },
//   {
//     labelKey: "deepGreen",
//     src: "/images/colorscale/colorscale_deepgreen.jpg",
//     thermal_palette: 21,
//   },
// ];
import { useEffect, useState } from "react";
import { useAppStore } from "lib/store/useAppStore";
import { postChangePalette } from "lib/api/postChangePalette";
import ImgEditor from "components/project/ImgEditor";
import SingleImageDownloadBtn from "components/project/SingleImageDownloadBtn";
import FileValueTable from "components/project/FileValueTable";
import TripleSpotOverlay from "components/project/FileImgEditor/TripleSpotOverlay";
import { getEditorSize } from "lib/utils/getEditorSize";

export default function ThermalPanel({
  file,
  refetch,
  circles,
  setCircles,
  currentPaletteOptionNumber,
  setCurrentPaletteOptionNumber,
  themralCaptureTargetDefault,
  tripleSpotCaptureTarget,
  currentThermalImg,
  setCurrentThermalImg,
  imgChangeLoading,
  setImgChangeLoading,
  t,
}) {
  const [changing, setChanging] = useState(false);
  const showAlert = useAppStore((s) => s.showAlert);
  const editorSize = getEditorSize(file?.csv_origin, "thermal");

  useEffect(() => {
    if (file?.thermal_palette != null) {
      setCurrentPaletteOptionNumber(file.thermal_palette);
    }
  }, [file?.thermal_palette, setCurrentPaletteOptionNumber]);

  return (
    <div className="thermalPanel">
      <PaletteOptionsList
        currentPaletteOptionNumber={currentPaletteOptionNumber}
        setCurrentPaletteOptionNumber={setCurrentPaletteOptionNumber}
        upload_id={file?.upload_id}
        refetch={refetch}
        changing={changing}
        setChanging={setChanging}
        setCurrentThermalImg={setCurrentThermalImg}
        imgChangeLoading={imgChangeLoading}
        setImgChangeLoading={setImgChangeLoading}
        showAlert={showAlert}
        t={t}
      />
      <div>
        <div>
          <div className="imgDownloadBtnBox">
            <p className="imgTitleP">
              {t("imageFileIndex.subTitle.shootingImage")}
            </p>
            <SingleImageDownloadBtn
              fileName={`${file?.clean_file_name}_thermal`}
              captureTargetRef={themralCaptureTargetDefault}
              t={t("imageFileIndex.buttons.singleImageDownload")}
            />
          </div>
          <div ref={themralCaptureTargetDefault}>
            <img src={file?.markup_image_thermal} alt="" />
          </div>
        </div>

        <div>
          <div className="imgDownloadBtnBox">
            <p className="imgTitleP">
              {t("imageFileIndex.subTitle.tripleSpot")}
            </p>
            <SingleImageDownloadBtn
              fileName={`${file?.clean_file_name}_triplespot`}
              captureTargetRef={tripleSpotCaptureTarget}
              t={t("imageFileIndex.buttons.singleImageDownload")}
            />
          </div>
          <div
            ref={tripleSpotCaptureTarget}
            style={{ width: editorSize.width, height: "480px" }}
            className="tripleSpotImgBox"
          >
            <TripleSpotOverlay
              file={file}
              circles={circles}
              setCircles={setCircles}
              editorSize={editorSize}
            />
            <img src={file?.image_thermal} alt="" />
          </div>
        </div>

        <div>
          <p className="imgTitleP">
            {t("imageFileIndex.subTitle.MeasurementValue")} {file?.volume}
          </p>
          <FileValueTable t={t} parsedData={file} type="thermal" />
        </div>
      </div>
    </div>
  );
}

export function PaletteOptionsList({
  currentPaletteOptionNumber,
  setCurrentPaletteOptionNumber,
  setCurrentThermalImg,
  upload_id,
  changing,
  setChanging,
  imgChangeLoading,
  setImgChangeLoading,
  showAlert,
  t,
}) {
  const handleClick = async (val) => {
    if (val === currentPaletteOptionNumber) return;
    if (!upload_id) return;
    if (changing) return;

    setChanging(true);
    setImgChangeLoading(true);
    const prev = currentPaletteOptionNumber;

    try {
      const { success, message, messageKey, messageParams, image } =
        await postChangePalette(upload_id, val);

      if (!success) {
        setCurrentPaletteOptionNumber(prev);
        showAlert({
          text: message,
          messageKey,
          messageParams,
          success,
          autoClose: true,
          duration: 3000,
        });
        return;
      }

      showAlert({
        text: message,
        messageKey,
        messageParams,
        success,
        autoClose: true,
        duration: 1000,
      });
      setCurrentThermalImg(image);
      setCurrentPaletteOptionNumber(val);
    } catch (e) {
      setCurrentPaletteOptionNumber(prev);
      showAlert({
        textKey: "api.project.palette.change.failed",
        success: false,
        autoClose: true,
      });
      console.error(e);
    } finally {
      setChanging(false);
      setImgChangeLoading(false);
    }
  };

  return (
    <ul className={`paletteOptionsList${changing ? " is-loading" : ""}`}>
      {paletteLabels.map(({ labelKey, src, thermal_palette }) => {
        const label = t(`imageFileIndex.paletteLabels.${labelKey}`);

        return (
          <li
            onClick={() => handleClick(thermal_palette)}
            key={labelKey}
            className={`paletteOption ${
              thermal_palette === currentPaletteOptionNumber ? "active" : ""
            } ${changing || imgChangeLoading ? "is-disabled" : ""}`}
          >
            <p>{label}</p>
            <img src={src} alt={label} />
          </li>
        );
      })}
    </ul>
  );
}

export const paletteLabels = [
  {
    labelKey: "autumn",
    src: "/images/colorscale/colorscale_autumn.jpg",
    thermal_palette: 0,
  },
  {
    labelKey: "bone",
    src: "/images/colorscale/colorscale_bone.jpg",
    thermal_palette: 1,
  },
  {
    labelKey: "jet",
    src: "/images/colorscale/colorscale_jet.jpg",
    thermal_palette: 2,
  },
  {
    labelKey: "winter",
    src: "/images/colorscale/colorscale_winter.jpg",
    thermal_palette: 3,
  },
  {
    labelKey: "rainbow",
    src: "/images/colorscale/colorscale_rainbow.jpg",
    thermal_palette: 4,
  },
  {
    labelKey: "ocean",
    src: "/images/colorscale/colorscale_ocean.jpg",
    thermal_palette: 5,
  },
  {
    labelKey: "summer",
    src: "/images/colorscale/colorscale_summer.jpg",
    thermal_palette: 6,
  },
  {
    labelKey: "spring",
    src: "/images/colorscale/colorscale_spring.jpg",
    thermal_palette: 7,
  },
  {
    labelKey: "cool",
    src: "/images/colorscale/colorscale_cool.jpg",
    thermal_palette: 8,
  },
  {
    labelKey: "hsv",
    src: "/images/colorscale/colorscale_hsv.jpg",
    thermal_palette: 9,
  },
  {
    labelKey: "pink",
    src: "/images/colorscale/colorscale_pink.jpg",
    thermal_palette: 10,
  },
  {
    labelKey: "hot",
    src: "/images/colorscale/colorscale_hot.jpg",
    thermal_palette: 11,
  },
  {
    labelKey: "parula",
    src: "/images/colorscale/colorscale_parula.jpg",
    thermal_palette: 12,
  },
  {
    labelKey: "magma",
    src: "/images/colorscale/colorscale_magma.jpg",
    thermal_palette: 13,
  },
  {
    labelKey: "inferno",
    src: "/images/colorscale/colorscale_inferno.jpg",
    thermal_palette: 14,
  },
  {
    labelKey: "plasma",
    src: "/images/colorscale/colorscale_plasma.jpg",
    thermal_palette: 15,
  },
  {
    labelKey: "viridis",
    src: "/images/colorscale/colorscale_viridis.jpg",
    thermal_palette: 16,
  },
  {
    labelKey: "cividis",
    src: "/images/colorscale/colorscale_cividis.jpg",
    thermal_palette: 17,
  },
  {
    labelKey: "twilight",
    src: "/images/colorscale/colorscale_twilight.jpg",
    thermal_palette: 18,
  },
  {
    labelKey: "shifted",
    src: "/images/colorscale/colorscale_twilight_shifted.jpg",
    thermal_palette: 19,
  },
  {
    labelKey: "turbo",
    src: "/images/colorscale/colorscale_turbo.jpg",
    thermal_palette: 20,
  },
  {
    labelKey: "deepGreen",
    src: "/images/colorscale/colorscale_deepgreen.jpg",
    thermal_palette: 21,
  },
];
